import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=b8ce7862&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=b8ce7862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ce7862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ce7862')) {
      api.createRecord('b8ce7862', component.options)
    } else {
      api.reload('b8ce7862', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=b8ce7862&scoped=true&", function () {
      api.rerender('b8ce7862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/Faq.vue"
export default component.exports